import { render, staticRenderFns } from "./index.vue?vue&type=template&id=034a27bd&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=034a27bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a27bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034a27bd')) {
      api.createRecord('034a27bd', component.options)
    } else {
      api.reload('034a27bd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=034a27bd&scoped=true&", function () {
      api.rerender('034a27bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_marginnote_landing/components/AppSale/index.vue"
export default component.exports